import { Modal } from "antd";
import styled from "styled-components";

export const CustomModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #12619c;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
